import { Component,HostListener, OnInit} from '@angular/core';
import { Router, RouterOutlet } from "@angular/router";
import { FooterComponent } from './modules/comum/footer/footer.component';
import { HeaderComponent } from './modules/comum/header/header.component';
import { NgIf } from '@angular/common';
import { LoaderComponent } from './modules/comum/loader/loader.component';
import { AuthService } from './core/auth/service/auth.service';
import { Globals } from './shared/helpers/globals';
import { AuthForm } from './core/auth/model/auth.model';
import { environment } from 'src/environments/environment';
import { StringUtil } from './shared/util/string-util';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    imports: [LoaderComponent, NgIf, HeaderComponent, RouterOutlet, FooterComponent]
})
export class AppComponent implements OnInit{
  showHead: boolean = false;

  constructor(
    private globals: Globals,
    private router: Router,
    private readonly _authService: AuthService) {
  }

  ngOnInit(): void {
    if (!this._authService.isAuthenticated) {
      this.handleUnauthenticatedUser();
    } else {
      this.showHead = true;
    }
  }

  public handleUnauthenticatedUser(): void {
    const url = window.location.search;
    const validationToken = StringUtil.extractParamUrl(url, 'token');
    const userId = StringUtil.extractParamUrl(url, 'userId');

    if (validationToken && userId) {
      const originClientId = environment.originClientId;
      const authForm: AuthForm = { userId, validationToken, originClientId };
      this.login(authForm);
    } else {
      environment.local ? this.handleLocalAuth() : this.router.navigate(['/login']);
    }
  }

  private handleLocalAuth(): void {
    const token = prompt('Informe o token para autenticação');
    if (token) {
      this._authService.saveSessionData(token).subscribe({
        next: (isAuthenticated: boolean) => this.handleSuccessLogin(isAuthenticated),
        error: (err) => this.handleLoginError(err),
        complete: () => this.globals.subtractFromLoading()
      });
      this.handleSuccessLogin(true);
    } else {
      this.router.navigate(['/login']);
    }
  }

  login(authForm: AuthForm): void {
    this.globals.addToLoading("login");

    this._authService.login(authForm).subscribe({
      next: (isAuthenticated: boolean) => this.handleSuccessLogin(isAuthenticated),
      error: (err) => this.handleLoginError(err),
      complete: () => this.globals.subtractFromLoading()
    });
  }

  private handleSuccessLogin(isAuthenticated: boolean): void {
    this.showHead = isAuthenticated;
    this.router.navigate(['/ordem']);
  }

  private handleLoginError(error: any): void {
    console.error('Erro ao autenticar:', error);
    this.globals.subtractFromLoading();
    this.router.navigate(['/error-auth'], {
        state: {
          msg: error,
        }
      });
  }

}
